export enum StoreKeys {
  ACCESS_TOKEN_KEY = 'accessToken',
  REFRESH_TOKEN_KEY = 'refreshToken',
  PUBNUB_TOKEN_KEY = 'pubnubtoken',
  USER_KEY = 'user',
  ROLES = 'roles',
  FILTERS = 'filters',
  TENANT_KEY = 'tenantName',
  TENANT_KEY_NAME = 'tenantKey',
  LOCALE = 'locale',
  PHR_CATEGORIES = 'phrCategories',
  PHR_TAGS = 'phrTags',
  HEALTH_TASKS = 'healthTasks',
  CMS_SUB_CATEGORIES_1 = 'cmsSubCategories1',
  CMS_SUB_CATEGORIES_2 = 'cmsSubCategories2',
  CMS_SUB_CATEGORIES_3 = 'cmsSubCategories3',
  CMS_CATEGORIES = 'cmsCategories',
  CMS_CONDITIONS = 'cmsConditions',
  CANCER_TYPES = 'cancerTypes',
  FOOD_CAT = 'foodCategories',
  FOOD_BENEFITS = 'foodBenefits',
  FOOD_UNIT = 'foodUnit',
  SIDE_EFFECTS = 'sideEffects',
  SIDE_EFFECT_SEVERITY = 'sideEffectSeverity',
  COMORBIDITIES = 'comorbidities',
  MOODS = 'moods',
  MOOD_LOG_COUNT = 'moodLogCount',
  CHAT_CATEGORIES = 'chatCategories',
  TENANT_DETAILS = 'tenantDetails',
  PasswordExpiryAlert = 'passwordExpiryAlert',
  CountryName = 'countryName',
  Logo = 'logo',
  IsWhiteLabelled = 'isWhiteLabelled',
  MonochromeLogo = 'monochromeLogo',
  IS_WHITE_LABELLED = 'isWhiteLabelled',
  TENANT_ID = 'tenantId',
  FeatureConfigs = 'featureConfigs',
  CANCER_TYPES_WITH_ICD_CODES = 'cancer-types-with-icd-codes',
  ACTIVE_SESSION_MODAL = 'active-session-modal',
  RELATIONSHIPS = 'relations',
  PATIENT_DIR_FILTER = 'patientDirFilter',
  PspList = 'patient-support-programs',
  LENAGIO_LOADER = 'LENAGIO_LOADER',
  WINDOW_UNLOAD = 'WINDOW_UNLOAD',
  LOGIN_PAYLOAD = 'LOGIN_PAYLOAD',
}
